/**
 * Mermaid chart renderer for product journey diagrams (Refactored Version)
 * Responsible for rendering diagrams and providing pan/zoom functionality
 * 
 * This is a drop-in replacement for mermaid-diagram-manager.js that uses
 * the new modular architecture but maintains the same API.
 * 
 * @module mermaidDiagramManager
 * @requires asyncUtils
 * @requires eventBus
 * @requires stateManager
 */

// Import the actual modules instead of recreating them
import diagramSystem from './diagram/index.js';

// Fallback to global dependencies if needed
if (typeof window.eventBus === 'undefined') {
  window.eventBus = { on: () => {}, off: () => {}, emit: () => {} };
}

if (typeof window.stateManager === 'undefined') {
  window.stateManager = { getState: () => ({}), setState: () => {}, subscribe: () => (() => {}) };
}

// Export the diagram system as a global variable with updated API
window.mermaidDiagramManager = {
  // Core functionality - only exposing a single diagram rendering function
  initMermaid: diagramSystem.initMermaid,
  renderDiagram: diagramSystem.renderDiagram,
  
  // Direct zoom control functions
  zoomIn: diagramSystem.zoomIn,
  zoomOut: diagramSystem.zoomOut,
  zoomReset: diagramSystem.reset,
  recenterForViewport: diagramSystem.recenterForViewport,
  restoreOriginalCenter: diagramSystem.restoreOriginalCenter,

  // Node centering functions
  centerNodeInViewport: diagramSystem.centerNodeInViewport,
  animatedZoomToNode: diagramSystem.animatedZoomToNode,
  
  // Internal functions for testing only
  initializeDiagramControls: diagramSystem.initializeDiagramControls,
  initializePanzoom: diagramSystem.initializePanzoom
};

// Handle module exports for environments that support it
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = window.mermaidDiagramManager;
}